/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import shadeBlendConvert from "./shadeBlendConvert";

export function getPrimaryButtonColor (widget) {
  if (widget && widget?.primary_button_background) {
    return widget?.primary_button_background;
  }
  return '#15aae0';
}

function getPrimaryButtonColorWithAlpha (widget) {
  if (widget && widget?.primary_button_background) {
    return `${widget?.primary_button_background}99`;
  }
  return '#15aae0AA';
}

function getHeaderBackgrounColor (widget) {
  if (widget && widget.header_background) {
    return widget.header_background;
  }
  return '#000000';
}

function getPrimaryButtonColorShaded ({ widget, defaultStatics }) {
  if (widget && widget?.primary_button_background) {
      return shadeBlendConvert(-0.20, widget.primary_button_background);
  }
  return shadeBlendConvert(-0.20, defaultStatics.grey3); ;
};

function getForeButtonColor ({ widget, defaultStatics }) {
  if (widget && widget?.foreground_button_color) {
    return widget.foreground_button_color;
  }
  return defaultStatics.grey3;
}

function getLogo ({ widget }) {
  const defaultLogo = '';

  const defaultStyles = {
    // width: '35px',
    // maxWidth: '350px',
    maxHeight: '120px',
    backgroundSize: 'auto 80px',
    backgroundColor: '#FFFFFF',
  };

  if (widget.logoTransparent || widget.logo_transparent) {
    defaultStyles.backgroundColor = '#FFFFFF00';
  }

  applyLogoProps({
    widget,
    defaultStyles,
  });

  if (widget && widget?.logo) {
      return {
        ...defaultStyles,
        // background: `transparent url(${widget.logo}) no-repeat center`,
      };
  }

  return {
    ...defaultStyles,
    background: `transparent url(${defaultLogo}) no-repeat center`,
  };
};

export function applyLogoProps ({ widget, defaultStyles }) {
  if (widget.logoShape === 'round') {
    
    defaultStyles.width = widget.logoWidth;
    defaultStyles.height = widget.logoHeight;
 
    defaultStyles.borderRadius =  widget.logoWidth / 2;
  } else {
    defaultStyles.height = widget.logoHeight;

  }

  if (widget.bannerType === 'dynamic') {
    // defaultStyles.marginTop = '8px';
  }

  if (widget.error) {
    defaultStyles.backgroundColor = 'transparent';
    defaultStyles.width = '80px';
    defaultStyles.height = '80px';
    defaultStyles.borderRadius =  '40px';
  }

  if (widget.version === '1') {
    // defaultStyles.backgroundColor = 'transparent';
    delete defaultStyles.maxWidth;
  }
} 

export function getButtonStyles ({ widgetTheme, widget }) {
    const wt = widgetTheme;

    const styles = {
        boxSizing: 'border-box',
        cursor: 'pointer',
        // color: getForeButtonColor({ widget, defaultStatics: wt.defaultStatics }),
        color: '#fff',
        textTransfrom: 'none',
        backgroundColor: getPrimaryButtonColor(widget),
        borderRadius: '100px',
        fontSize: '1em',
        fontWeight: wt.baseFontWeight,
        // padding: `${wt.paddingSmall} ${wt.paddingExtraLarge}`,
        // borderBottom: `2px ${getPrimaryButtonColorShaded({widget, defaultStatics: wt.defaultStatics})} solid`,
        maxWidth: '70%',
        minWidth: '165px',
        height: '40px',
        outline: 'none',
        lineHeight: '1.15',
        transition: 'background-color 100ms ease-out',
    
        '&.MuiButton-text': {
          textTransform: 'none',
        },

        '&.MuiButton-root': {
          '&[disabled]': {
            backgroundColor: '#ABABAB',
            color: '#F1F1F1',
          },

          '&:hover': {
            backgroundColor: getPrimaryButtonColorShaded({
              widget,
              defaultStatics: wt.defaultStatics,
            }),
          },
        },
    };

    return styles;
}

export function getCopyLinkButtonStyles ({ widgetTheme, widget }) {
  const wt = widgetTheme;
  const styles = {
      boxSizing: 'border-box',
      cursor: 'pointer',
      color: '#fff',
      textTransfrom: 'none',
      backgroundColor: getPrimaryButtonColor(widget),
      fontSize: '0.75em',
      fontWeight: wt.baseFontWeight,
      minWidth: '85px',
      height: '30px',
      outline: 'none',
      lineHeight: '1.15',
      transition: 'background-color 300ms ease-out',
  
      '&.MuiButton-text': {
        textTransform: 'none',
        fontFamily: 'GothamRounded-Book',
      },
       
      '&:hover': {
        backgroundColor: getPrimaryButtonColorShaded({
          widget,
          defaultStatics: wt.defaultStatics,
        }),
      },

      '&[disabled]': {
        backgroundColor: '#ABABAB !important',
        color: '#F1F1F1',
      },
  };

  return styles;
}

function getBorderTopStyles  ({ widget, isOauthTalking }) {
  if (isOauthTalking) {
    return {};
  }
  return {
    borderTop:   `6px ${getPrimaryButtonColor(widget)} solid`,
  };
}

function getListItemCheck ({ widget }) {
  return {
    color: getPrimaryButtonColor(widget),
    backgroundColor: '#FFFFFF',
  };
}

function getThumbnailText ({ widget, selected, view }) {
  if (view === 'calendar') {
    return {
      color: getHeaderBackgrounColor(widget),
    }
  }

  return {
    // color: selected ? getPrimaryButtonColor(widget) : '#000000',
    color: selected && '#15aae0',
  };
}

function getHeaderTitleText ({error, widget }) {
  if (error) {
    return '#F10000';
  }
  return  getHeaderBackgrounColor(widget);
}

function getTextLink ({ widget }) {
  return {
    color: getPrimaryButtonColor({ widget })
  }
}

function getLogoSpace ({ widget }) {
  const w = widget;
  const styles = {};
  if (w.bannerType === 'dynamic') {
    styles.top = `calc(132px - ${widget.logoHeight / 2}px)`;
  } else {
    styles.top = `calc(84px - ${widget.logoHeight / 2}px)`;
  }
   
  if (w.error) {
    styles.top = `calc(84px - ${widget.logoHeight / 2}px)`;
  }

  return styles;
}

function getContentSpace ({ widget }) {
  if (!widget) return {};

  const w = widget;
  const styles = {};
  // minus the height of header icons
  const m = 12;
  const barHeight = 44;
  let marginTop = 0;
  if (w.bannerType === 'dynamic') {
    marginTop = (132 - barHeight) + (widget.logoHeight / 2) + m;
  } else {
    marginTop = (84 - barHeight) + (widget.logoHeight / 2) + m;
  }

  if (w.error) {
    marginTop = (84 - barHeight) + (widget.logoHeight / 2) + m;
  }

  styles.marginTop = marginTop;
  styles.height = `calc(100% - ${marginTop}px - 40px)`;
  return styles;
}

export default function getCommonUIStyles (props) {
  const commonUIStyles = {
    logo: () => getLogo(props),
    logoSpace: () => getLogoSpace(props),
    contentSpace: () => getContentSpace(props),
    button: () => getButtonStyles(props),
    copyLinkButton: () => getCopyLinkButtonStyles(props),
    borderTop: () => getBorderTopStyles(props),
    listItemCheck: () => getListItemCheck(props),
    thumbnailText: (params) => getThumbnailText(params),
    headerTitleText: (params) => getHeaderTitleText(params),
    textLink: () => getTextLink(props),
    getPrimaryButtonColor: () => getPrimaryButtonColor(props),
    primaryWithColorAlpha: () => getPrimaryButtonColorWithAlpha(props),
    foreColor: () => {
      return getForeButtonColor({
        widget: props.widget,
        defaultStatics: props.widgetTheme.defaultStatics,
      });
    }
  };
  return commonUIStyles;
}

export function useCommonUIStyles (p) {
  const {
    widgetTheme,
    widget,
  } = p;

  const [commonUIStyles, setCommonUIStyles] = useState(getCommonUIStyles({ widgetTheme, widget }));
  useEffect(() => {
    setCommonUIStyles(getCommonUIStyles({ widgetTheme, widget }));
  }, [widgetTheme, widget]);

  return {
    commonUIStyles,
  };
};
